import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { take } from 'rxjs/operators';
import { ListarPedidosService } from 'src/app/services/listar-pedidos.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { ConfirmarCancelamentoComponent } from './confirmar-cancelamento/confirmar-cancelamento.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { NgClass, CurrencyPipe } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-listar-pedidos-cancelar',
    templateUrl: './listar-pedidos-cancelar.component.html',
    styleUrls: ['./listar-pedidos-cancelar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, ConfirmarCancelamentoComponent, BreadcrumbComponent, NgClass, RouterLink, FooterComponent, CurrencyPipe, AppDatePipe]
})
export class ListarPedidosCancelarComponent implements OnInit {

  public idPedido: number;
  public pedidosPraCancelar: any = null;
  public idEmpresaLogada: string;
  public inputSelecionados: any = [];
  public statusApi: any = 'null';
  public confirmaCancelamento: boolean = false;
  public mensagemErro: string;

  constructor(public router: Router, private readonly service: ListarPedidosService) { }

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    this.getAllPedidos();
  }

  getAllPedidos() {

    this.pedidosPraCancelar = null;

    this.service.getAllPedidosCancelar(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status == 'OK' && response.response?.length) {
          this.pedidosPraCancelar = response.response;
        } else {
          this.pedidosPraCancelar = undefined;
        }
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }

  selecionaTodos(input: any) {

    let checkboxes = document.querySelectorAll("input[type='checkbox']");

    function transformAllTrue(item: any) { item.checked = true; }
    function transformAllFalse(item: any) { item.checked = false; }

    if(input.checked === true) {
      checkboxes.forEach(transformAllTrue);
    } else {
      checkboxes.forEach(transformAllFalse);
    }

  }

  detalharPedido(idPedido: number, idEmpresa: number) {
    this.router.navigate(['listar-pedidos-detalhes'], {queryParams: { idPedido: idPedido, idEmpresa: idEmpresa }});
  }

  confirmacaoCancelamento() {
    let checkboxes: any = document.querySelectorAll('input[name="inputsCancelamento"]:checked');

    if(checkboxes?.length) {
      this.mensagemErro = '';
      this.confirmaCancelamento = true;
    } else {
      this.mensagemErro = 'Escolha os pedidos a serem cancelados!';
    }
  }

  respostaConfirmacao(resposta: string) {
    this.confirmaCancelamento = false;
    if(resposta === 'Confirmar') { this.cancelarPedidosSelecionados(); }
  }

  cancelarPedidosSelecionados() {

    this.mensagemErro = '';
    this.inputSelecionados = [];
    let arrayPedidos = [];

    let checkboxes: any = document.querySelectorAll('input[name="inputsCancelamento"]:checked');

    if(checkboxes?.length) {

      for (const input of checkboxes) {
        this.inputSelecionados.push(input.title);
      }

      arrayPedidos = this.inputSelecionados.map(Number);

      window.scroll(0, 0);
      this.statusApi = 'carregando';

      this.service.cancelarPedidos(arrayPedidos)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status == 'OK') {
            this.statusApi = 'sucesso';
            this.getAllPedidos();
          }
        },
        error: (erro: any) => {
          this.statusApi = 'erro';
          console.error(erro);
        }
      });
    }
  }

  goBackPage() { window.history.back(); }

  fecharStatusApi() { this. statusApi = 'null'; }
}
